/// <reference path="../../../app.definition.ts" />
interface IPageNotifier {
    pageName: any;

    init(): void;
}

class PageNotifier implements IPageNotifier {
    pageName: boolean;

    static $inject = ['hsq'];
    constructor(
        private hsq
    ) {
        console.log("Constructing pageCompleteNotifier for Analytics for page", this.pageName);
    }

    init(): void {
        console.log("Sending pageView to Analytics for page", this.pageName);
        this.hsq.push(['setPath', '/' + this.pageName]);
        this.hsq.push(['trackPageView']);
    }
}

function pageNotifier(): ng.IDirective {
    return {
        restrict: 'E',
        replace: false,
        controller: PageNotifier,
        bindToController: {
            'pageName': '@pageName'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IPageNotifier): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.directives').directive('pageCompleteNotifier', pageNotifier);
